// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 헤더 */
header.intro {
  height: 100px;
  display: flex;
  justify-content: center;
}
header.intro .header_wrap {
  width: 1280px;
  display: block;
  height: 100%;
}
header.intro .intro_logo {
  float: left;
  line-height: 100px;
}
header.intro .intro_logo img {
  width: 152px;
  height: auto;
  image-rendering: -webkit-optimize-contrast;
  transform: translateZ(0);
  backface-visibility: hidden;
}
@media screen and (max-width: 1280px) {
  header.intro {
    padding: 0 20px;
  }
}

#login_form {
  width: 100%;
  float: left;
}
#login_form .int_container {
  width: 100%;
  max-width: 1280px;
  display: block;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
#login_form .int_container .int_wrap {
  padding: 0 20px;
}
#login_form .int_container .int_wrap .auth-form {
  background: #fff;
  width: 600px;
  padding: 60px 40px;
  margin: 89px auto;
  border-radius: 5px;
  border: 1px solid #eee;
  position: relative;
}
#login_form .int_container .int_wrap .auth-form h1 {
  font-weight: bold;
  text-align: center;
  font-size: 2.5rem;
}
#login_form .int_container .int_wrap .auth-form .Loginform {
  display: block;
  unicode-bidi: isolate;
}
#login_form .int_container .int_wrap .auth-form .Loginform .form-group {
  margin-bottom: 15px;
}
#login_form .int_container .int_wrap .auth-form .Loginform .form-group .hide {
  display: none;
}
#login_form .int_container .int_wrap .auth-form .Loginform .form-group .inputBox {
  margin-top: 10px;
}
#login_form .int_container .int_wrap .auth-form .Loginform .form-group .inputBox input {
  height: 60px;
  width: 100%;
}
#login_form .int_container .int_wrap .auth-form .Loginform .form-group .inputBox input:focus {
  box-shadow: 0 0 5px #9ed4ff;
  border-color: #558ab7 !important;
}
#login_form .int_container .int_wrap .auth-form .Loginform .form-group .btn {
  font-size: 2rem !important;
  background: #2ca6e0 !important;
  border: 0;
  color: #fff;
  margin: 0 0 10px;
}
#login_form .int_container .int_wrap .auth-form .Loginform .find-login {
  display: flex;
  justify-content: space-between;
}

footer#int_ft.sub_ft {
  background: none;
  border-top: 1px solid #ebebeb;
}
footer#int_ft.sub_ft a {
  color: #9f9f9f;
}
footer#int_ft.sub_ft .int_container {
  width: 100%;
  max-width: 1280px;
  display: block;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
footer#int_ft.sub_ft .int_container .int_wrap {
  display: flex;
  align-items: flex-start;
}
@media screen and (max-width: 1280px) {
  footer#int_ft.sub_ft .int_container .int_wrap {
    padding: 0 20px;
  }
}
footer#int_ft.sub_ft .int_container .int_wrap .ft_logo a {
  color: #9f9f9f;
}
footer#int_ft.sub_ft .int_container .int_wrap .ft_logo a img {
  width: 90px;
}
footer#int_ft.sub_ft .int_container .int_wrap .f_list .f_link a {
  color: #9f9f9f;
}

#sample {
  position: relative;
  z-index: 5;
  margin-right: 20px;
  width: 60px;
  height: 35px;
}
#sample dt {
  width: 100%;
  height: 100%;
}
#sample button {
  width: 100%;
  height: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#sample button i {
  font-size: 1.7rem;
}
#sample .dropdown dd,
#sample .dropdown dt,
#sample .dropdown ul {
  margin: 0;
  padding: 0;
}
#sample .dropdown dd {
  position: relative;
}
#sample .dropdown button,
#sample .dropdown button:visited {
  text-decoration: none;
  outline: none;
}
#sample .dropdown a:hover {
  color: #000;
}
#sample .dropdown dt button:hover,
#sample .dropdown dt button:focus {
  border: 1px solid rgb(128, 128, 128);
}
#sample .dropdown dt button {
  background: #fff no-repeat scroll right center;
  display: block;
  border-radius: 3px;
  padding: 0 7px;
  border: 1px solid rgb(170, 170, 170);
  width: 150px;
}
#sample .dropdown dt button span {
  cursor: pointer;
  display: block;
  padding: 5px;
}
#sample .dropdown dd ul {
  background: #fff none repeat scroll 0 0;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  display: none;
  left: 0;
  position: absolute;
  top: 6px;
  width: auto;
  min-width: 60px;
  list-style: none;
}
#sample .dropdown span.value {
  display: none;
}
#sample .dropdown dd ul li button {
  padding: 10px;
  display: block;
}
#sample .dropdown dd ul li button:hover {
  background-color: #e9e9e9;
}
#sample .dropdown img.flag {
  border: none;
  vertical-align: middle;
  margin-left: 10px;
}
#sample .dropdown .flagvisibility {
  display: none;
}

.prf_wrap {
  position: relative;
}
.prf_wrap .mypage_btn_wrap {
  display: none;
  position: absolute;
  bottom: -130px;
  z-index: 10;
  background: #fff;
  width: 110px;
  right: 20px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.16);
}
.prf_wrap .mypage_btn_wrap li {
  width: 100%;
}
.prf_wrap .mypage_btn_wrap li button,
.prf_wrap .mypage_btn_wrap li a {
  padding: 10px;
  width: 100%;
  height: 100%;
  text-align: left;
  display: block;
  text-decoration: none !important;
  font-size: 1.4rem;
}
.prf_wrap .mypage_btn_wrap li button:hover,
.prf_wrap .mypage_btn_wrap li a:hover {
  background: #eee;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/css/login.css","webpack://./src/components/Login/css/login.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,OAAA;AACA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;ADEF;ACAE;EACE,aAAA;EACA,cAAA;EACA,YAAA;ADEJ;ACCE;EACE,WAAA;EACA,kBAAA;ADCJ;ACCI;EACE,YAAA;EACA,YAAA;EACA,0CAAA;EACA,wBAAA;EACA,2BAAA;ADCN;ACIE;EAzBF;IA2BI,eAAA;EDFF;AACF;;ACOA;EACE,WAAA;EACA,WAAA;ADJF;ACME;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;ADJJ;ACMI;EACE,eAAA;ADJN;ACMM;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;ADJR;ACMQ;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;ADJV;ACOQ;EACE,cAAA;EACA,qBAAA;ADLV;ACOU;EACE,mBAAA;ADLZ;ACOY;EACE,aAAA;ADLd;ACQY;EACE,gBAAA;ADNd;ACQc;EACE,YAAA;EACA,WAAA;ADNhB;ACQgB;EAGE,2BAAA;EACA,gCAAA;ADNlB;ACYY;EACE,0BAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;ADVd;ACeU;EACE,aAAA;EACA,8BAAA;ADbZ;;AC6CA;EACE,gBAAA;EACA,6BAAA;AD1CF;AC4CE;EACE,cAAA;AD1CJ;AC6CE;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AD3CJ;AC6CI;EACE,aAAA;EACA,uBAAA;AD3CN;AC6CM;EAJF;IAKI,eAAA;ED1CN;AACF;AC8CQ;EACE,cAAA;AD5CV;AC8CU;EACE,WAAA;AD5CZ;ACmDU;EACE,cAAA;ADjDZ;;AC6DA;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AD1DF;AC4DE;EACE,WAAA;EACA,YAAA;AD1DJ;AC6DE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AD3DJ;AC6DI;EACE,iBAAA;AD3DN;ACiEI;;;EAGE,SAAA;EACA,UAAA;AD/DN;ACkEI;EACE,kBAAA;ADhEN;ACmEI;;EAEE,qBAAA;EACA,aAAA;ADjEN;ACoEI;EACE,WAAA;ADlEN;ACqEI;;EAEE,oCAAA;ADnEN;ACsEI;EACE,8CAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,oCAAA;EACA,YAAA;ADpEN;ACsEM;EACE,eAAA;EACA,cAAA;EACA,YAAA;ADpER;ACwEI;EACE,uCAAA;EACA,uCAAA;EACA,aAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;ADtEN;ACyEI;EACE,aAAA;ADvEN;AC0EI;EACE,aAAA;EACA,cAAA;ADxEN;AC0EM;EACE,yBAAA;ADxER;AC4EI;EACE,YAAA;EACA,sBAAA;EACA,iBAAA;AD1EN;AC6EI;EACE,aAAA;AD3EN;;ACiFA;EACE,kBAAA;AD9EF;ACiFE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,uCAAA;AD/EJ;ACiFI;EACE,WAAA;AD/EN;ACiFM;;EAEE,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,iBAAA;AD/ER;ACiFQ;;EACE,gBAAA;AD9EV","sourcesContent":["@charset \"UTF-8\";\n/* 헤더 */\nheader.intro {\n  height: 100px;\n  display: flex;\n  justify-content: center;\n}\nheader.intro .header_wrap {\n  width: 1280px;\n  display: block;\n  height: 100%;\n}\nheader.intro .intro_logo {\n  float: left;\n  line-height: 100px;\n}\nheader.intro .intro_logo img {\n  width: 152px;\n  height: auto;\n  image-rendering: -webkit-optimize-contrast;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n@media screen and (max-width: 1280px) {\n  header.intro {\n    padding: 0 20px;\n  }\n}\n\n#login_form {\n  width: 100%;\n  float: left;\n}\n#login_form .int_container {\n  width: 100%;\n  max-width: 1280px;\n  display: block;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n#login_form .int_container .int_wrap {\n  padding: 0 20px;\n}\n#login_form .int_container .int_wrap .auth-form {\n  background: #fff;\n  width: 600px;\n  padding: 60px 40px;\n  margin: 89px auto;\n  border-radius: 5px;\n  border: 1px solid #eee;\n  position: relative;\n}\n#login_form .int_container .int_wrap .auth-form h1 {\n  font-weight: bold;\n  text-align: center;\n  font-size: 2.5rem;\n}\n#login_form .int_container .int_wrap .auth-form .Loginform {\n  display: block;\n  unicode-bidi: isolate;\n}\n#login_form .int_container .int_wrap .auth-form .Loginform .form-group {\n  margin-bottom: 15px;\n}\n#login_form .int_container .int_wrap .auth-form .Loginform .form-group .hide {\n  display: none;\n}\n#login_form .int_container .int_wrap .auth-form .Loginform .form-group .inputBox {\n  margin-top: 10px;\n}\n#login_form .int_container .int_wrap .auth-form .Loginform .form-group .inputBox input {\n  height: 60px;\n  width: 100%;\n}\n#login_form .int_container .int_wrap .auth-form .Loginform .form-group .inputBox input:focus {\n  box-shadow: 0 0 5px #9ed4ff;\n  border-color: #558ab7 !important;\n}\n#login_form .int_container .int_wrap .auth-form .Loginform .form-group .btn {\n  font-size: 2rem !important;\n  background: #2ca6e0 !important;\n  border: 0;\n  color: #fff;\n  margin: 0 0 10px;\n}\n#login_form .int_container .int_wrap .auth-form .Loginform .find-login {\n  display: flex;\n  justify-content: space-between;\n}\n\nfooter#int_ft.sub_ft {\n  background: none;\n  border-top: 1px solid #ebebeb;\n}\nfooter#int_ft.sub_ft a {\n  color: #9f9f9f;\n}\nfooter#int_ft.sub_ft .int_container {\n  width: 100%;\n  max-width: 1280px;\n  display: block;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\nfooter#int_ft.sub_ft .int_container .int_wrap {\n  display: flex;\n  align-items: flex-start;\n}\n@media screen and (max-width: 1280px) {\n  footer#int_ft.sub_ft .int_container .int_wrap {\n    padding: 0 20px;\n  }\n}\nfooter#int_ft.sub_ft .int_container .int_wrap .ft_logo a {\n  color: #9f9f9f;\n}\nfooter#int_ft.sub_ft .int_container .int_wrap .ft_logo a img {\n  width: 90px;\n}\nfooter#int_ft.sub_ft .int_container .int_wrap .f_list .f_link a {\n  color: #9f9f9f;\n}\n\n#sample {\n  position: relative;\n  z-index: 5;\n  margin-right: 20px;\n  width: 60px;\n  height: 35px;\n}\n#sample dt {\n  width: 100%;\n  height: 100%;\n}\n#sample button {\n  width: 100%;\n  height: 100%;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n#sample button i {\n  font-size: 1.7rem;\n}\n#sample .dropdown dd,\n#sample .dropdown dt,\n#sample .dropdown ul {\n  margin: 0;\n  padding: 0;\n}\n#sample .dropdown dd {\n  position: relative;\n}\n#sample .dropdown button,\n#sample .dropdown button:visited {\n  text-decoration: none;\n  outline: none;\n}\n#sample .dropdown a:hover {\n  color: #000;\n}\n#sample .dropdown dt button:hover,\n#sample .dropdown dt button:focus {\n  border: 1px solid rgb(128, 128, 128);\n}\n#sample .dropdown dt button {\n  background: #fff no-repeat scroll right center;\n  display: block;\n  border-radius: 3px;\n  padding: 0 7px;\n  border: 1px solid rgb(170, 170, 170);\n  width: 150px;\n}\n#sample .dropdown dt button span {\n  cursor: pointer;\n  display: block;\n  padding: 5px;\n}\n#sample .dropdown dd ul {\n  background: #fff none repeat scroll 0 0;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);\n  display: none;\n  left: 0;\n  position: absolute;\n  top: 6px;\n  width: auto;\n  min-width: 60px;\n  list-style: none;\n}\n#sample .dropdown span.value {\n  display: none;\n}\n#sample .dropdown dd ul li button {\n  padding: 10px;\n  display: block;\n}\n#sample .dropdown dd ul li button:hover {\n  background-color: #e9e9e9;\n}\n#sample .dropdown img.flag {\n  border: none;\n  vertical-align: middle;\n  margin-left: 10px;\n}\n#sample .dropdown .flagvisibility {\n  display: none;\n}\n\n.prf_wrap {\n  position: relative;\n}\n.prf_wrap .mypage_btn_wrap {\n  display: none;\n  position: absolute;\n  bottom: -130px;\n  z-index: 10;\n  background: #fff;\n  width: 110px;\n  right: 20px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.16);\n}\n.prf_wrap .mypage_btn_wrap li {\n  width: 100%;\n}\n.prf_wrap .mypage_btn_wrap li button,\n.prf_wrap .mypage_btn_wrap li a {\n  padding: 10px;\n  width: 100%;\n  height: 100%;\n  text-align: left;\n  display: block;\n  text-decoration: none !important;\n  font-size: 1.4rem;\n}\n.prf_wrap .mypage_btn_wrap li button:hover,\n.prf_wrap .mypage_btn_wrap li a:hover {\n  background: #eee;\n}/*# sourceMappingURL=login.css.map */","/* 헤더 */\r\nheader.intro {\r\n  height: 100px;\r\n  display: flex;\r\n  justify-content: center;\r\n\r\n  .header_wrap {\r\n    width: 1280px;\r\n    display: block;\r\n    height: 100%;\r\n  }\r\n\r\n  .intro_logo {\r\n    float: left;\r\n    line-height: 100px;\r\n\r\n    img {\r\n      width: 152px; // 이미지의 너비 조정\r\n      height: auto; // 높이 자동 조정\r\n      image-rendering: -webkit-optimize-contrast; // 이미지 렌더링 최적화\r\n      transform: translateZ(0); // GPU 가속을 통한 부드러운 애니메이션\r\n      backface-visibility: hidden; // 3D 변환 요소의 뒷면 가리기\r\n      // -webkit-perspective: 1; // 3D 변환에 대한 원근 거리 지정\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 1280px) {\r\n    // 1280px 이하에서 패딩 조정\r\n    padding: 0 20px;\r\n  }\r\n\r\n  // .intro_join {}\r\n}\r\n\r\n#login_form {\r\n  width: 100%;\r\n  float: left;\r\n\r\n  .int_container {\r\n    width: 100%;\r\n    max-width: 1280px;\r\n    display: block;\r\n    margin: 0 auto;\r\n    position: relative;\r\n    z-index: 1;\r\n\r\n    .int_wrap {\r\n      padding: 0 20px;\r\n\r\n      .auth-form {\r\n        background: #fff;\r\n        width: 600px;\r\n        padding: 60px 40px;\r\n        margin: 89px auto;\r\n        border-radius: 5px;\r\n        border: 1px solid #eee;\r\n        position: relative;\r\n\r\n        h1 {\r\n          font-weight: bold;\r\n          text-align: center;\r\n          font-size: 2.5rem;\r\n        }\r\n\r\n        .Loginform {\r\n          display: block;\r\n          unicode-bidi: isolate;\r\n\r\n          .form-group {\r\n            margin-bottom: 15px;\r\n\r\n            .hide {\r\n              display: none;\r\n            }\r\n\r\n            .inputBox {\r\n              margin-top: 10px;\r\n\r\n              input {\r\n                height: 60px;\r\n                width: 100%;\r\n\r\n                &:focus {\r\n                  -webkit-box-shadow: 0 0 5px #9ed4ff;\r\n                  -moz-box-shadow: 0 0 5px #9ed4ff;\r\n                  box-shadow: 0 0 5px #9ed4ff;\r\n                  border-color: #558ab7 !important;\r\n                }\r\n\r\n              }\r\n            }\r\n\r\n            .btn {\r\n              font-size: 2rem !important;\r\n              background: #2ca6e0 !important;\r\n              border: 0;\r\n              color: #fff;\r\n              margin: 0 0 10px;\r\n            }\r\n\r\n          }\r\n\r\n          .find-login {\r\n            display: flex;\r\n            justify-content: space-between;\r\n\r\n          }\r\n\r\n        }\r\n\r\n        // .inputBox input {\r\n        //   height: 60px;\r\n        //   width: 100%;\r\n        // }\r\n\r\n        // .find-login {\r\n        //   display: flex;\r\n        //   justify-content: space-between;\r\n        // }\r\n\r\n        // .form-group .btn {\r\n        //   font-size: 2rem !important;\r\n        //   background: #2ca6e0 !important;\r\n        //   border: 0;\r\n        //   color: #fff;\r\n        //   margin: 0 0 10px;\r\n        // }\r\n\r\n        // .inputBox {\r\n        //   margin-top: 10px;\r\n        // }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nfooter#int_ft.sub_ft {\r\n  background: none;\r\n  border-top: 1px solid #ebebeb;\r\n\r\n  a {\r\n    color: #9f9f9f;\r\n  }\r\n\r\n  .int_container {\r\n    width: 100%;\r\n    max-width: 1280px;\r\n    display: block;\r\n    margin: 0 auto;\r\n    position: relative;\r\n    z-index: 1;\r\n\r\n    .int_wrap {\r\n      display: flex;\r\n      align-items: flex-start;\r\n\r\n      @media screen and (max-width: 1280px) {\r\n        padding: 0 20px;\r\n      }\r\n\r\n      .ft_logo {\r\n\r\n        a {\r\n          color: #9f9f9f;\r\n\r\n          img {\r\n            width: 90px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .f_list {\r\n        .f_link {\r\n          a {\r\n            color: #9f9f9f;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n// 샘플\r\n#sample {\r\n  position: relative;\r\n  z-index: 5;\r\n  margin-right: 20px;\r\n  width: 60px;\r\n  height: 35px;\r\n\r\n  dt {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  button {\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: left;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    i {\r\n      font-size: 1.7rem;\r\n    }\r\n  }\r\n\r\n  .dropdown {\r\n\r\n    dd,\r\n    dt,\r\n    ul {\r\n      margin: 0;\r\n      padding: 0;\r\n    }\r\n\r\n    dd {\r\n      position: relative;\r\n    }\r\n\r\n    button,\r\n    button:visited {\r\n      text-decoration: none;\r\n      outline: none;\r\n    }\r\n\r\n    a:hover {\r\n      color: #000;\r\n    }\r\n\r\n    dt button:hover,\r\n    dt button:focus {\r\n      border: 1px solid rgb(128, 128, 128);\r\n    }\r\n\r\n    dt button {\r\n      background: #fff no-repeat scroll right center;\r\n      display: block;\r\n      border-radius: 3px;\r\n      padding: 0 7px;\r\n      border: 1px solid rgb(170, 170, 170);\r\n      width: 150px;\r\n\r\n      span {\r\n        cursor: pointer;\r\n        display: block;\r\n        padding: 5px;\r\n      }\r\n    }\r\n\r\n    dd ul {\r\n      background: #fff none repeat scroll 0 0;\r\n      box-shadow: 0 0 5px rgb(0 0 0 / 15%);\r\n      display: none;\r\n      left: 0;\r\n      position: absolute;\r\n      top: 6px;\r\n      width: auto;\r\n      min-width: 60px;\r\n      list-style: none;\r\n    }\r\n\r\n    span.value {\r\n      display: none;\r\n    }\r\n\r\n    dd ul li button {\r\n      padding: 10px;\r\n      display: block;\r\n\r\n      &:hover {\r\n        background-color: #e9e9e9;\r\n      }\r\n    }\r\n\r\n    img.flag {\r\n      border: none;\r\n      vertical-align: middle;\r\n      margin-left: 10px;\r\n    }\r\n\r\n    .flagvisibility {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// 프로필 랩\r\n.prf_wrap {\r\n  position: relative;\r\n\r\n  // 마이페이지 버튼 랩\r\n  .mypage_btn_wrap {\r\n    display: none;\r\n    position: absolute;\r\n    bottom: -130px;\r\n    z-index: 10;\r\n    background: #fff;\r\n    width: 110px;\r\n    right: 20px;\r\n    box-shadow: 0 0 5px rgb(0 0 0 / 16%);\r\n\r\n    li {\r\n      width: 100%;\r\n\r\n      button,\r\n      a {\r\n        padding: 10px;\r\n        width: 100%;\r\n        height: 100%;\r\n        text-align: left;\r\n        display: block;\r\n        text-decoration: none !important;\r\n        font-size: 1.4rem;\r\n\r\n        &:hover {\r\n          background: #eee;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
